import { useScreen } from 'common/hooks/useScreen';
import { useWebView } from 'store/webView/useWebView';
import { isMobilePlatform } from 'store/webView/webViewHelpers';

export const usePanelMobileView = () => {
  const { isMobileScreen } = useScreen();
  const { isWebView, webViewPlatform } = useWebView();

  return { isMobileView: isWebView ? isMobilePlatform(webViewPlatform) : isMobileScreen };
};
